"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const toggler = {
  bg: 'field.1',
  activeBg: 'interactive.inverse.active',
  borderRadius: 24,
  padding: 'xxsmall',
  height: 48,
  width: '100%'
};
const commonTab = {
  borderRadius: 24,
  height: 40,
  width: '50%',
  boxShadow: 'none',
  activeText: {
    color: 'text.3',
    colorDisabled: 'disabled.3'
  },
  inactiveText: {
    color: 'text.1',
    colorDisabled: 'disabled.2'
  }
};
const primary = { ...commonTab,
  bg: 'interactive.primary.default',
  disabledBg: 'disabled.2'
};
const secondary = { ...commonTab,
  bg: 'background.default',
  disabledBg: 'background.default',
  boxShadow: [0, 0, 0, 1, 'interactive.inverse.active', true],
  activeText: {
    color: 'text.1',
    colorDisabled: 'disabled.2'
  }
};
const buy = { ...commonTab,
  bg: 'interactive.buy.default',
  disabledBg: 'disabled.2',
  activeText: {
    color: 'text.3',
    colorDisabled: 'disabled.2'
  }
};
const sell = { ...commonTab,
  bg: 'interactive.sell.default',
  disabledBg: 'disabled.2',
  activeText: {
    color: 'text.3',
    colorDisabled: 'disabled.2'
  }
};
const theme = {
  toggler,
  buy,
  primary,
  secondary,
  sell
};
exports.theme = theme;
//# sourceMappingURL=ToggleButton.theme.js.map